import type { ICapturedAadtExtracted, ICapturedAadtFeatureCollection } from '@/types';

/**
 * Extracts top-level value and feature properties from a captured AADT FeatureCollection.
 * @param featureCollection - The ICapturedAadtFeatureCollection to extract data from
 * @returns Object with top-level value and array of route properties in feature order
 */
export function extractCapturedAadtData(
  featureCollection: ICapturedAadtFeatureCollection,
): ICapturedAadtExtracted {
  return {
    value: featureCollection.properties.value,
    routes: featureCollection.features.map((feature) => feature.properties),
  };
}
